import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { UnidadeService } from '../../shared/services/unidade.service';
import { EditalCredenciamentoService } from '../../editalCredenciamento/edital-credenciamento.service';
import { ArquivoService } from '../../shared/services/arquivo.service';

@Component({
  templateUrl: './visualizar-editais-cfc.component.html'
})
export class VisualizarEditaisCfcComponent extends WebPage implements OnInit {

  ufs;
  unidades;
  editais;

  constructor(
    messageService: MessageService,
    private _unidadeService: UnidadeService,
    private _editalCredenciamentoService: EditalCredenciamentoService,
    private _arquivoService: ArquivoService
  ) {
    super(messageService);
  }

  ngOnInit() {
    const mensagem = localStorage.getItem('mensagem');
    if (mensagem != null && mensagem !== '') {
      this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: mensagem });
      localStorage.removeItem('mensagem');
    }

    this.isLoading = true;
    this._unidadeService.getUfsComEditalCfc()
      .finally(() => this.isLoading = false)
      .subscribe(
        ufs => this.ufs = ufs,
        error => this.gerenciaErro(error)
      );
  }

  carregarUnidades(idUf) {
    if (idUf === '') {
      this.unidades = [];
      this.editais = [];
      return;
    }

    this.isLoading = true;
    this._unidadeService.getUnidadesComEditalCfcByIdUf(idUf)
      .finally(() => this.isLoading = false)
      .subscribe(
        unidades => this.unidades = unidades,
        error => this.gerenciaErro(error)
      );
  }

  carregarEditais(idUnidade) {
    if (idUnidade === '') {
      this.editais = [];
      return;
    }

    this.isLoading = true;
    this._editalCredenciamentoService.getEditalCfcByIdUnidade(idUnidade)
      .finally(() => this.isLoading = false)
      .subscribe(
        editais => { 
          this.editais = editais;
          
        console.log(editais);

        },
        error => this.gerenciaErro(error)
      );
  }

  downloadEdital(idArquivo) {
    this._arquivoService.downloadArquivo(idArquivo, 'Edital_Credenciamento_CFC');
  }

}



// WEBPACK FOOTER //
// ./src/app/components/cfc/visualizar-editais-cfc/visualizar-editais-cfc.component.ts